<template>
    <div class="event-screen home w-100 h-100" :class="{ 'event-entry': is_event_guest }">
        <!-- Event mode's MANAGER role lands here during IDLE (see client.js's
             handle_client()) - this is the "big screen" meant to be
             projected, so it shows the join QR/code instead of the plain
             waiting screen everyone else sees. -->
        <div v-if="is_manager_big_screen" class="position-fixed w-100 h-100 text-center d-flex justify-content-center align-items-center flex-column">
            <span class="home-title mb-4">VueltaCiclista</span>
            <h2 class="home-join-title">{{ active_season ? ('Únete a ' + active_season.name) : 'Únete' }} escaneando el código</h2>
            <JoinCodeQR :code="active_season_join_code" :size="320" />
        </div>

        <div v-else class="position-fixed w-100 h-100 text-center d-flex justify-content-center align-items-center flex-column">
            <template v-if="!is_event_guest">
                <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="home-icon mb-3"><circle cx="6" cy="17" r="3"/><circle cx="18" cy="17" r="3"/><path d="M6 17 10 8h5l3 9M10 8 8 4H5"/></svg>
                <span class="home-title">VueltaCiclista</span>
            </template>
            <button type="button" class="btn btn-primary mt-4" v-if="is_online_mode && !is_guest" @click="$router.push({name: 'MySeasons'})">{{ 'Mis ' + utils.get_season_label(window_mode, true).toLowerCase() }}</button>
            <template v-if="is_online_mode && is_guest">
                <button type="button" class="btn btn-primary mt-4" @click="$router.push({name: 'Register'})">Crear cuenta</button>
                <a href="#" class="mt-3" @click.prevent="$router.push({name: 'Login'})">Ya tengo cuenta</a>
            </template>
            <!-- Event-mode GUEST with no active AUTH window and no deep link -
                 the only other way to reach Auth.vue's registration wizard.
                 Lets a late guest join mid-stage by typing/scanning the code
                 shown on the manager's screen (see JoinByCode.vue). -->
            <JoinByCode v-if="is_event_guest" class="mt-4" />
        </div>
    </div>
</template>

<script>
import JoinCodeQR from '@/components/JoinCodeQR.vue'
import JoinByCode from '@/components/JoinByCode.vue'

export default {
    name: 'Home',
    components: {
        JoinCodeQR,
        JoinByCode,
    },
    data(){
        return {
            utils: require('../../../shared/utils'),
            window_mode: window.MODE,
        };
    },
    computed: {
        is_online_mode(){
            return window.MODE == this.utils.APP_MODES.ONLINE;
        },
        is_manager_big_screen(){
            return !this.is_online_mode
                && this.$store.state.game.user
                && this.$store.state.game.user.role == this.utils.USER_ROLES.MANAGER;
        },
        // Whichever event the moderator has "loaded" right now (see
        // server.js's game.active_season_id / validate_join_code) - this
        // projector screen shows THAT event's own QR, so players scanning
        // it land in Auth.vue already tied to it (jersey model included,
        // see jersey_model.js) instead of the flat whole-game code.
        active_season(){
            return (this.$store.state.game.seasons || []).find((s) => s.id == this.$store.state.game.active_season_id) || null;
        },
        active_season_join_code(){
            return this.active_season ? this.active_season.join_code : null;
        },
        // Online identity lives in state.online_user (REST-based, see
        // store/index.js), not game.user (websocket-based) - an online
        // player never logs in over the websocket, so game.user stays GUEST
        // for them forever. Point a not-yet-logged-in visitor at
        // Register/Login instead of a "Mis temporadas" button that would
        // just bounce them back here (see router/index.js's
        // ONLINE_PLAYER_ROUTES guard).
        is_guest(){
            return !this.$store.state.online_user;
        },
        is_event_guest(){
            return !this.is_online_mode
                && this.$store.state.game.user
                && this.$store.state.game.user.role == this.utils.USER_ROLES.GUEST;
        }
    },
    mounted(){
        if(window.store.state.network == "connected"){
            window.network.wso.send(
                JSON.stringify(
                    {
                        action: window.RPC.UPDATE_VIEW, 
                        params: {
                            view: window.router.currentRoute._value.name, 
                            activity: (this.$store.state.game.current_question) ? this.$store.state.game.question.question.id : null
                        }
                    }
                )
            )
        }
        $('.modal-backdrop').remove();
    },
    created(){
    }
}
</script>

<style scoped>
    .home{
        user-select: none;
    }

    .home-icon{
        color: var(--vc-accent-500);
    }

    .home-title{
        font-family: "Archivo", sans-serif;
        font-weight: 800;
        text-transform: uppercase;
        letter-spacing: 0.03em;
        font-size: 1.4rem;
        color: var(--vc-ink-900);
    }

    .home-join-title{
        font-family: "Archivo", sans-serif;
        font-weight: 800;
        font-size: 2rem;
        margin-bottom: 1.5rem;
        color: var(--vc-ink-900);
    }
</style>